/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../src/app/licensing/licensing.component';
import * as i2 from '@angular/router';
const styles_LicensingComponent:any[] = ([] as any[]);
export const RenderType_LicensingComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_LicensingComponent,data:{}});
export function View_LicensingComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),0,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any)))],(null as any),
      (null as any));
}
export function View_LicensingComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'licensing-component',
      ([] as any[]),(null as any),(null as any),(null as any),View_LicensingComponent_0,
      RenderType_LicensingComponent)),i0.ɵdid(114688,(null as any),0,i1.LicensingComponent,
      [i2.Router],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const LicensingComponentNgFactory:i0.ComponentFactory<i1.LicensingComponent> = i0.ɵccf('licensing-component',
    i1.LicensingComponent,View_LicensingComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy91aS9zcmMvYXBwL2xpY2Vuc2luZy9saWNlbnNpbmcuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy91aS9zcmMvYXBwL2xpY2Vuc2luZy9saWNlbnNpbmcuY29tcG9uZW50LnRzIiwibmc6Ly8vc3JjL3VpL3NyYy9hcHAvbGljZW5zaW5nL2xpY2Vuc2luZy5jb21wb25lbnQudHMuTGljZW5zaW5nQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9zcmMvdWkvc3JjL2FwcC9saWNlbnNpbmcvbGljZW5zaW5nLmNvbXBvbmVudC50cy5MaWNlbnNpbmdDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2PjwvZGl2PiIsIjxsaWNlbnNpbmctY29tcG9uZW50PjwvbGljZW5zaW5nLWNvbXBvbmVudD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTs7OztvQkNBQTtNQUFBO21DQUFBLFVBQUE7TUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// ./aot_output/src/app/licensing/licensing.component.ngfactory.ts